// Static product / content data for Sobtrex landing page

export const FEATURED = [
  { name: "Brushless Impact Drill", tag: "20V Cordless", icon: "Drill" },
  { name: "Brushless Angle Grinder", tag: "20V Cordless", icon: "Disc3" },
  { name: "26mm Rotary Hammer", tag: "SDS-Plus", icon: "Hammer" },
  { name: "4-Tool Combo Kit", tag: "20V Platform", icon: "Package" },
];

export const CORDED = [
  { name: "13mm Impact Drill", spec: "600–650W", icon: "Drill" },
  { name: "13mm Impact Drill", spec: "800–850W", icon: "Drill" },
  { name: "100mm Angle Grinder", spec: "850–900W", icon: "Disc3" },
  { name: "26mm SDS-Plus Rotary Hammer", spec: "Corded", icon: "Hammer" },
  { name: "Electric Blower", spec: "600W", icon: "Wind" },
  { name: "Heat Gun", spec: "2000W", icon: "Flame" },
];

export const CORDLESS = [
  { name: "Brushless Drill Driver", icon: "Drill" },
  { name: "Brushless Impact Drill", icon: "Drill" },
  { name: "Brushless Impact Driver", icon: "Wrench" },
  { name: "Brushless Angle Grinder", icon: "Disc3" },
  { name: "Brushless Rotary Hammer", icon: "Hammer" },
  { name: "Brushless Impact Wrench", icon: "Wrench" },
  { name: "Brushless Circular Saw", icon: "CircleDot" },
  { name: "Brushless Reciprocating Saw", icon: "Waves" },
  { name: "Brushless Jig Saw", icon: "Slice" },
  { name: "Brushless Oscillating Multi Tool", icon: "Cog" },
  { name: "Brushless Blower", icon: "Wind" },
  { name: "Brushless Hedge Trimmer", icon: "Scissors" },
  { name: "Brushless Grass Trimmer", icon: "Sprout" },
  { name: "Brushless Chainsaw", icon: "Axe" },
];

export const BATTERY = [
  { name: "2.0Ah Battery", icon: "BatteryLow" },
  { name: "4.0Ah Battery", icon: "BatteryMedium" },
  { name: "5.0Ah Battery", icon: "BatteryFull" },
  { name: "Fast Charger", icon: "Zap" },
  { name: "Dual-Port Charger", icon: "PlugZap" },
  { name: "Carrying Case", icon: "Briefcase" },
  { name: "4-Tool Combo Kit", icon: "Package" },
];

export const WHY = [
  { title: "Professional Quality", icon: "BadgeCheck", desc: "Engineered to demanding professional standards." },
  { title: "Reliable Performance", icon: "Activity", desc: "Consistent power, job after job." },
  { title: "Industrial Durability", icon: "ShieldCheck", desc: "Built to survive the toughest sites." },
  { title: "High Value", icon: "TrendingUp", desc: "Premium capability at a smart price." },
  { title: "Powerful Battery Platform", icon: "BatteryCharging", desc: "One 20V battery across every tool." },
  { title: "Excellent Ergonomics", icon: "Hand", desc: "Balanced, comfortable, all-day control." },
  { title: "Long-Term Spare Parts", icon: "Cog", desc: "Support that lasts the tool's lifetime." },
  { title: "Dedicated Service Network", icon: "Headphones", desc: "Nationwide service you can rely on." },
  { title: "OEM Manufactured", icon: "Factory", desc: "Precision manufacturing, verified quality." },
  { title: "Future Product Ecosystem", icon: "Layers", desc: "A growing family of professional tools." },
];

export const VALUES = ["Innovation", "Quality", "Reliability", "Customer First", "Continuous Improvement"];

export const ROADMAP = [
  {
    phase: "Phase 1",
    label: "Now",
    items: ["Professional Corded Power Tools", "Professional Cordless 20V Platform"],
  },
  {
    phase: "Phase 2",
    label: "Next",
    items: ["Woodworking Equipment", "Metalworking Equipment", "Garden Tools", "Professional Accessories", "Hand Tools", "Safety Equipment", "Storage Systems"],
  },
  {
    phase: "Future",
    label: "Vision",
    items: ["Industrial Machinery", "Workshop Equipment", "Professional Service Network", "National Dealer Network", "Export Markets"],
  },
];

export const BUSINESS_TYPES = ["Dealer", "Distributor", "Retailer", "Importer", "Contractor", "Industrial Buyer", "OEM", "Other"];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1519638157102-4da934548801?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkYXJrJTIwaW5kdXN0cmlhbCUyMHdvcmtzaG9wfGVufDB8fHx8MTc4NTU2OTI5Nnww&ixlib=rb-4.1.0&q=85",
  tools: "/sobtrex-tools.png",
  grinder: "https://images.unsplash.com/reserve/7vjJbdDRga27ApDoYicw_Sparks.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxhbmdsZSUyMGdyaW5kZXIlMjBzcGFya3N8ZW58MHx8fHwxNzg1NTY5Mjk2fDA&ixlib=rb-4.1.0&q=85",
  worker: "https://images.pexels.com/photos/3658574/pexels-photo-3658574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  logo: "/sobtrex-logo.png",
};

export const TAGLINES = [
  "Professional Power Tools Engineered for Performance",
  "Built Tough. Built Smart.",
  "Precision. Power. Performance.",
  "Engineered for Every Job.",
];
